import { render, staticRenderFns } from "./CambioContrasenia.vue?vue&type=template&id=308fc7ef"
import script from "./CambioContrasenia.vue?vue&type=script&lang=js"
export * from "./CambioContrasenia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports